var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7953 13.4946L50.6607 0.106201L46.5262 13.4946L38.5273 17.3035L46.5614 21.1294L50.6607 32.8419L54.7601 21.1294L62.7943 17.3035L54.7953 13.4946ZM49.4627 16.0338L50.6607 12.1545L51.8588 16.0338L54.5253 17.3035L51.894 18.5565L50.6607 22.0802L49.4275 18.5565L46.7963 17.3035L49.4627 16.0338Z",
    fill: "url(#paint0_linear_4576_683)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1066 17.6839L24.8841 10.5737L26.6617 17.6839L31.9944 19.4615L26.6617 21.2391L24.8841 28.3493L23.1066 21.2391L17.7739 19.4615L23.1066 17.6839Z",
    fill: "url(#paint1_linear_4576_683)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4429 59.8999V60.3386C12.4429 62.3019 10.8513 63.8937 8.88777 63.8937H3.55511C1.59168 63.8937 0 62.3019 0 60.3386V40.7937C0 38.8304 1.59168 37.2386 3.55511 37.2386H8.88777C10.5693 37.2386 11.9782 38.4061 12.3481 39.9748C14.7023 39.1263 17.452 38.1165 18.2933 37.7329C19.0079 37.4074 19.8331 37.2969 20.5187 37.2572C21.2396 37.2156 21.9876 37.2444 22.6421 37.2951C23.3023 37.3461 23.9015 37.4224 24.3342 37.4853C24.5514 37.5169 24.7292 37.5456 24.8545 37.5665C24.9172 37.5772 24.967 37.5857 25.0022 37.5921L25.044 37.5996L25.0562 37.6019L25.0626 37.603L25.0944 37.609L36.9842 40.2762L37.0585 40.3001L37.0787 40.3063L37.1607 40.3313C37.2355 40.3539 37.3491 40.3872 37.4956 40.4277C37.789 40.5091 38.211 40.6188 38.7141 40.7284C39.736 40.9513 41.0233 41.1595 42.2237 41.1595C43.3327 41.1595 44.4799 41.5728 45.0932 42.696C45.6199 43.6603 45.4972 44.7192 45.3001 45.4525C45.0546 46.3651 44.5462 47.3255 43.8999 48.1414C44.7722 47.8124 45.7256 47.4227 46.7491 47.0029L46.968 46.9129C49.8529 45.7291 53.2738 44.3251 56.2912 43.8262C59.7392 43.2558 62.2487 44.5073 63.3863 46.7279C64.399 48.7043 64.1638 51.2985 62.6398 52.8615C62.2572 53.2538 61.6744 53.6653 61.089 54.045C60.4641 54.4503 59.6942 54.9083 58.8388 55.3934C57.1256 56.3652 55.0048 57.4822 52.8755 58.5621C48.6591 60.7005 44.2394 62.7801 42.835 63.2943C41.2074 63.8905 39.4592 63.9469 37.778 63.8603C36.8622 63.8132 35.7983 63.7074 34.7409 63.6022C33.9769 63.5263 33.2164 63.4506 32.5177 63.3978C29.0909 63.1381 26.4609 62.3017 24.0382 61.5313L23.7437 61.4377C21.2416 60.6434 18.9139 59.939 15.8298 59.8148C15.1247 59.7863 13.7167 59.838 12.4429 59.8999ZM19.7678 40.9679C19.8818 40.916 20.184 40.8378 20.7236 40.8065C21.2277 40.7773 21.8029 40.7958 22.3679 40.8395C22.9271 40.8829 23.444 40.9483 23.8224 41.0033C24.0105 41.0306 24.1621 41.0552 24.2647 41.0724C24.3161 41.0811 24.3548 41.0879 24.3799 41.0923L24.3838 41.093L36.0579 43.7119L36.138 43.7362C36.2351 43.7654 36.3732 43.8057 36.546 43.8537C36.891 43.9494 37.3779 44.0756 37.9563 44.2018C38.9965 44.4288 40.3901 44.6682 41.8107 44.7087C41.7094 44.9962 41.5379 45.3355 41.3054 45.6734C41.0217 46.0858 40.7101 46.4047 40.4543 46.5873C39.7138 47.1163 39.1161 47.3376 38.7534 47.4318C38.5697 47.4794 38.4405 47.4959 38.3767 47.5016L38.353 47.5036L38.3392 47.5043L28.8079 47.3891L28.4677 50.9153L28.7864 49.1665L28.4695 50.9156L28.5641 50.9327L28.8351 50.9814C29.0698 51.0235 29.4077 51.0836 29.8231 51.1563C30.6532 51.3017 31.7935 51.4976 33.0334 51.6995C35.4764 52.0977 38.4211 52.5389 40.0919 52.6397C41.2457 52.7093 42.5895 52.3552 43.8393 51.9379C45.1435 51.5026 46.6167 50.8998 48.0983 50.2919C51.1509 49.0398 54.2591 47.7656 56.8714 47.3337C59.1296 46.96 59.9334 47.785 60.2223 48.3488C60.6361 49.1567 60.4111 50.0547 60.0945 50.3795C60.0168 50.4591 59.7368 50.6845 59.1545 51.0623C58.6118 51.4142 57.9092 51.8337 57.0849 52.3012C55.4387 53.2348 53.372 54.3241 51.2675 55.3915C47.0165 57.5475 42.785 59.5266 41.6124 59.9561C40.6628 60.3039 39.4893 60.3885 37.9609 60.3098C37.0581 60.2634 36.2017 60.1763 35.2679 60.0812C34.5132 60.0044 33.7078 59.9227 32.7863 59.8528C29.779 59.6249 27.4927 58.8986 25.0427 58.1202L24.8195 58.0493C22.2818 57.2437 19.5664 56.4072 15.9729 56.2625C15.164 56.23 13.7238 56.2799 12.4429 56.3405V43.7183C14.9412 42.8242 18.6414 41.4814 19.7678 40.9679ZM24.7368 39.3505L25.0626 37.603C25.063 37.6031 25.0626 37.603 24.7368 39.3505ZM8.88777 40.7937H3.55511V60.3386H8.88777V40.7937Z",
    fill: "url(#paint2_linear_4576_683)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4576_683",
    x1: 24.1973,
    y1: 3.12855,
    x2: 172.138,
    y2: 80.7539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4576_683",
    x1: 9.37652,
    y1: 12.2149,
    x2: 93.0943,
    y2: 59.6203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4576_683",
    x1: -37.7931,
    y1: 39.6984,
    x2: 90.1872,
    y2: 257.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.1a1c8144a299a15adf7166b8ea6c5621.svg";
export { ForwardRef as ReactComponent };